<template>
  <div id="app" :class="oldHtml == true ? 'oldCss' : ''">
    <el-container>
      <!-- <el-header
        height="64px"
        class="flex sys-header"
        v-show="!$route.meta.hideHeaderFooter"
      >
        <div class="oldPeople" @click="openOld"><span v-if="!oldHtml">长辈</span><span v-if="oldHtml">退出</span><br/>模式</div>
        <div class="header-one">
          <div class="sys-title" @click="gotoHome">
            <img class="block logoShow" src="./assets/bule-zhe.png" />
            <div class="flex-crew">
              <div class="crew-title-one">船员</div>
              <div class="crew-title-two">船员,就上浙船员</div>
            </div>
          </div>
          <div class="header-two">
            <ul>
              <li
                @click="gojob"
                style="cursor: pointer"
                :class="hoverIndex == 1 ? 'hoverApp' : 'none-hover'"
              >
                船员求职
              </li>
              <li
                @click="gotrain"
                style="cursor: pointer"
                :class="hoverIndex == 2 ? 'hoverApp' : 'none-hover'"
              >
                船员培训
              </li>
              <li
                @click="columnList"
                style="cursor: pointer"
                :class="hoverIndex == 3 ? 'hoverApp' : 'none-hover'"
              >
                海事专栏
              </li>
              <li
                @click="noInformation('4')"
                style="cursor: pointer"
                :class="hoverIndex == 4 ? 'hoverApp' : 'none-hover'"
              >
                健康体检
              </li>
              <li
                @click="noInformation('5')"
                style="cursor: pointer"
                :class="hoverIndex == 5 ? 'hoverApp' : 'none-hover'"
              >
                船员咨询
              </li>
              <li
                @click="noInformation('6')"
                style="cursor: pointer"
                :class="hoverIndex == 6 ? 'hoverApp' : 'none-hover'"
              >
                航运百科
              </li>
              <li
                @click="noInformation('7')"
                style="cursor: pointer"
                :class="hoverIndex == 7 ? 'hoverApp' : 'none-hover'"
              >
                关于我们
              </li>
            </ul>
          </div>
          <div class="head-three">
            <img v-if="userType == 2" src="./assets/waterUser.png" alt="" />
            <img v-if="userType == 4" src="./assets/owner-user.png" alt="" />
            <img
              v-if="
                userType == '0' ||
                userType == 1 ||
                userType == 3 ||
                userType == 5 ||
                userType == 6
              "
              src="./assets/company-user.png"
              alt=""
            />
            <el-button
              type="primary"
              size="small"
              class="login-primary"
              @click="toLogin"
              v-if="!userName"
              >登录</el-button
            >
            <el-button
              size="small"
              @click="toReset"
              class="register-primary"
              v-if="!userName"
              >注册</el-button
            >
            <el-dropdown
              @command="handleCommand"
              v-if="userName"
              class="drop-width"
            >
              <span class="el-dropdown-link" :title="userName">
                {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">切换用户</el-dropdown-item>
                <el-dropdown-item command="b">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header> -->
      <!-- <div style="height: 64px" v-show="!$route.meta.hideHeaderFooter"></div> -->
      <el-main class="sys-main">
        <router-view />
      </el-main>
      <!-- <el-footer
        style="padding: 0"
        v-show="!$route.meta.hideHeaderFooter && !$route.meta.hideFooter"
      >
        <div class="footer-info">
          <div class="wrapper">
            <div class="footer-link clearfix">
              <div class="fl f-logo">
                <img
                  class="block logoShow"
                  src="./assets/logoShow.png"
                  alt="蓝水母平台logo"
                />
                <p class="logoShow-text">航运业服务平台</p>
              </div>
              <dl class="fl" style="width: 50%">
                <dt>联系我们</dt>
                <dt>
                  地址：宁波市鄞州区鼎泰路399号宁波保税区国际贸易中心2101-04室、杭州市文三路90号东部软件园科技大厦1405室
                </dt>
                <dt>电话：(宁波)18100132729、(杭州)0571-28888137</dt>
                <dt>邮箱：market@allhigh.com.cn</dt>
              </dl>
              <div class="wechat fr">
                <img class="code" src="./assets/wechat-code.jpg" alt="" />
                <p class="text-center">关注蓝水母微信二维码</p>
              </div>
            </div>
            <div class="footer-copyright text-center">
              <p>
                <span>海泓网络（宁波）有限公司版权所有 © 2015-2020</span>
                <span
                  ><a
                    style="color: rgba(255, 255, 255, 0.4)"
                    href="https://beian.miit.gov.cn"
                    target="_blank"
                    >浙ICP备15040128号</a
                  ></span
                ><span>增值电信业务经营许可证：浙B2-2010586</span>
              </p>
              <p class="record"><span>浙公网安备 33021202001626号</span></p>
            </div>
          </div>
        </div>
      </el-footer> -->
    </el-container>
  </div>
</template>

<script>
// import router from "@/router";
import { removeStorage } from "@/utils/auth";
import { apiUrl } from "@/config";
import { login } from "@/apis/index";
import { setStorage } from "@/utils/auth";
export default {
  name: "App",
  data() {
    return {
      userName: "",
      userType: "",
      inoformationView: false,
      hoverIndex: 0,
      oldHtml: false,
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.getUser();
        // console.log(val); //新路由信息
        // console.log(oldval); //老路由信息
        switch (val.fullPath) {
          case "/maritimeColumn":
            this.hoverIndex = 3;
            break;
          case "/healthView":
            this.hoverIndex = 4;
            break;
          case "/crewProblem":
            this.hoverIndex = 5;

            break;
          case "/shipInformation":
            this.hoverIndex = 6;
            break;
          case "/aboutUs":
            this.hoverIndex = 7;
            break;
          case "/maritimeDeclaration":
            this.hoverIndex = 3;
            break;
          default:
            this.hoverIndex = 0;
            break;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    const tolog = this.$route.query.tolog;
    if (tolog) {
      const loginName = tolog.split("split")[0];
      const password = tolog.split("split")[0];
      this.loginUser(loginName, password);
    }
    this.getUser();
    this.getPath();
    var screenWidth = window.innerWidth;
    var fontSize = screenWidth * (14 / 1366); // 假设每个 rem 等于屏幕宽度的 1/100
    document.documentElement.style.fontSize = fontSize + "px";
    // this.$router.push("/home");
    // window.addEventListener("resize", function () {
    //   console.log("我的");
    //   var screenWidth = window.innerWidth;
    //   var fontSize = screenWidth * (14 / 1366); // 假设每个 rem 等于屏幕宽度的 1/100
    //   document.documentElement.style.fontSize = fontSize + "px";
    // });
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    openOld() {
      this.oldHtml = !this.oldHtml;
    },
    gotoHome() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push("/home");
    },
    toReset() {
      this.$router.push("/register");
    },
    getPath() {
      switch (this.$route.path) {
        case "/maritimeColumn":
          this.hoverIndex = 3;
          break;
        case "/healthView":
          this.hoverIndex = 4;
          break;
        case "/crewProblem":
          this.hoverIndex = 5;

          break;
        case "/shipInformation":
          this.hoverIndex = 6;
          break;
        case "/aboutUs":
          this.hoverIndex = 7;
          break;
        case "/maritimeDeclaration":
          this.hoverIndex = 3;
          break;
        default:
          this.hoverIndex = 0;
          break;
      }
    },

    getUser() {
      this.userName = sessionStorage.getItem("loginName");
      let postName = sessionStorage.getItem("postName");
      this.userType = sessionStorage.getItem("userType");
      if (postName) {
        // console.log();
        // console.log(postName.indexOf(":"));
        if (postName.indexOf(":") > -1) {
          postName = postName.split(":")[1];
          this.userName = postName;
          console.log(this.userName);
        } else {
          this.userName = postName;
        }
      }
    },
    noInformation(type) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      switch (type) {
        case "4":
          this.$router.push("/healthView");
          break;
        case "5":
          this.$router.push("/crewProblem");
          break;
        case "6":
          this.$router.push("/shipInformation");
          break;
        case "7":
          this.$router.push("/aboutUs");
          break;

        default:
          break;
      }
    },
    columnList() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push("/maritimeColumn");
    },
    handleCommand(command) {
      if (command == "b") {
        removeStorage();
        this.userName = "";
        this.userType = "";
        this.$router.push("/home");
      } else if (command == "a") {
        removeStorage();
        this.userName = "";
        this.userType = "";
        this.$router.push("/login");
      }
    },
    gojob() {
      let menuType = sessionStorage.getItem("menuType") || "";
      if (menuType == 1) {
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/companyHome?tolog=${sessionStorage.getItem(
          "tolog"
        )}&companyId=${sessionStorage.getItem("companyId")}`;
      } else {
        if (
          sessionStorage.getItem("tolog") &&
          (sessionStorage.getItem("userType") == 0 ||
            sessionStorage.getItem("userType") == 5 ||
            sessionStorage.getItem("userType") == 4)
        ) {
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/crewHome?tolog=${sessionStorage.getItem(
            "tolog"
          )}`;
        } else {
          sessionStorage.clear();
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/crewHome?homeTitle=true`;
        }
      }
    },
    gotrain() {
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        sessionStorage.getItem("userType") == 6 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/home?tolog=${sessionStorage.getItem(
          "tolog"
        )}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/home?homeTitle=true`;
      }
    },
    async loginUser(loginName, password) {
      const res = await login({
        plainPassword: loginName,
        loginName: password,
      });
      if (!res.code) {
        this.$message({
          message: "用户名或密码错误",
          type: "warning",
        });
      } else if (res.code == "1") {
        sessionStorage.setItem("tolog", loginName + "split" + password);
        var data = res.data;
        if (
          data.companyType == "0" &&
          data.userType == "0" &&
          data.isLand == "1" &&
          data.isRecruitSystemAdmin == "1"
        ) {
          data.menuType = 1;
        } else if (data.companyType == "2" && data.userType == "5") {
          data.menuType = 1;
        } else if (
          data.companyType == "0" &&
          data.userType == "0" &&
          data.isRecruitSystemAdmin == "0"
        ) {
          data.menuType = 2;
        } else if (data.userType == "4") {
          data.menuType = 2;
        }
        setStorage(data);
        this.$router.push("/home");
      }
    },
  },
};
</script>

<style>
.none-hover {
  font-size: 16px;
  font-family: Microsoft YaHei;
}
.hoverApp:after {
  content: "";
  position: absolute;
  bottom: 8px;
  right: 5px;
  height: 4px;
  border-radius: 4px;
  width: 53px;
  background-color: #27e8e7;
}
.none-hover:after {
  content: "";
  position: absolute;
  bottom: 8px;
  right: 5px;
  height: 4px;
  border-radius: 4px;
  width: 53px;
  background-color: #27e8e7;
  opacity: 0;
}
.none-hover:hover:after {
  opacity: 1;
}
</style>
